import AutoBind from 'auto-bind'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(SplitText, ScrollTrigger)

export default class Animation {
  constructor() {
    // AutoBind(this)
    this.quote = document.querySelector('.c-home__hero__quote h1')
    this.author = document.querySelectorAll('.c-home__hero__quote__author div')
    this.header = document.querySelector('.c-header')
    this.headerItems = document.querySelectorAll('[data-animation="header"]')
    this.images = document.querySelectorAll('[data-animation="image"]')
    this.text = document.querySelectorAll('[data-animation="text"]')

    this.intro()
    this.scrollAnimation()
  }

  intro() {
    this.timeline = gsap.timeline()
    this.media = gsap.matchMedia()
    this.split = new SplitText(this.quote, { type: 'lines' })

    this.media.add('(max-width: 899px)', () => {
      this.timeline
        .set(this.quote, {
          autoAlpha: 1,
        })
        .fromTo(this.split.lines, {
          y: 50,
          autoAlpha: 0,
        }, {
          y: 0,
          stagger: 0.2,
          autoAlpha: 1,
          duration: 1.2,
          ease: 'power2.out',
        })
        .fromTo(this.author, {
          y: 50,
        }, {
          y: 0,
          autoAlpha: 1,
          stagger: 0.2,
          duration: 1.2,
          ease: 'power2.out',
        }, '-=0.8')
        .to(this.header, {
          autoAlpha: 1,
          duration: 1,
        }, '-=0.6')
    })

    this.media.add('(min-width: 900px)', () => {
      this.timeline
        .set(this.quote, {
          autoAlpha: 1,
        })
        .fromTo(this.split.lines, {
          y: 100,
          autoAlpha: 0,
        }, {
          y: 0,
          stagger: 0.2,
          autoAlpha: 1,
          duration: 1.2,
          ease: 'power2.out',
        })
        .to(this.headerItems, {
          autoAlpha: 1,
          duration: 1,
          stagger: 0.2,
        }, '-=0.4')
    })
  }

  scrollAnimation() {
    this.images.forEach((item) => {
      this.timelineImages = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top 70%',
        },
      })

      const imagesInner = item.querySelector('img')

      this.timelineImages.to(item, {
        transformOrigin: 'top',
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1.6,
        ease: 'expo.inOut',
      }).from(imagesInner, {
        scale: 1.3,
        duration: 1.6,
        ease: 'expo.inOut',
      }, '-=1.6')
    })

    this.text.forEach((item) => {
      gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top 80%',
        },
        autoAlpha: 1,
        duration: 1,
      })
    })
  }
}
